import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HiOutlineCollection, 
  HiOutlineStar, 
  HiOutlinePencilAlt, 
  HiOutlineLightBulb,
  HiOutlineMenu,
  HiOutlineX
} from 'react-icons/hi';
import { MdStickyNote2 } from 'react-icons/md';

function Sidebar({ isOpen, onToggle, categories, activeCategory, onCategorySelect }) {
  const location = useLocation();
  
  const navigation = [
    { name: 'Biblioteca', path: '/', icon: HiOutlineCollection },
    { name: 'Criar frase', path: '/create-phrase', icon: HiOutlinePencilAlt },
    { name: 'Meus Favoritos', path: '/favorites', icon: HiOutlineStar },
    { name: 'Sugestão de figurinha', path: '/sticker-suggestion', icon: HiOutlineLightBulb },
  ];
  
  const isActive = (path) => location.pathname === path;
  const isCategoryActive = (category) => location.pathname === `/category/${category.id}`;
  
  return (
    <>
      {/* Toggle Button */}
      <button 
        className="sidebar-toggle"
        onClick={onToggle}
        aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
      >
        {isOpen ? <HiOutlineX /> : <HiOutlineMenu />}
      </button>
      
      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* Logo */}
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-icon">
              <MdStickyNote2 />
            </div>
            <span>Biblioteca</span>
          </div>
        </div>
        
        {/* Navigation */}
        <nav className="nav-section">
          <div className="nav-section-title">Navegar</div>
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => onCategorySelect(null)}
            >
              <span className="nav-item-icon">
                <item.icon />
              </span>
              <span className="nav-item-label">{item.name}</span>
            </Link>
          ))}
        </nav>
        
        {/* Categories */}
        <nav className="nav-section">
          <div className="nav-section-title">Categorias</div>
          <div className="categories-list">
            {categories.map((category) => (
              <Link
                key={category.id}
                to={`/category/${category.id}`}
                className={`category-nav-item ${isCategoryActive(category) ? 'active' : ''}`}
                onClick={() => onCategorySelect(category)}
              >
                <span className="category-nav-emoji">{category.emoji}</span>
                <span className="category-nav-name">{category.name}</span>
              </Link>
            ))}
          </div>
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
